<template>
  <transition name="fade">
    <div class="flex flex-col items-center absolute pin-y pin-l mt-26 ml-2.5 z-1000">
      <div class="py-4 px-2 w-64 rounded bg-white">
        <div class="text-black text-sm font-bold text-center">{{ mutationInfo.teacher.nama }}</div>
        <div class="mt-1 text-grey-dark text-xs text-center font-bold">{{ mutationInfo.course }}</div>
        <div class="my-2" style="border-bottom: 1px solid #999; width: 100%;"></div>
        <div class="flex flex-col w-full px-2">
          <div class="flex flex-row mt-1">
            <div class="w-1/3 text-black text-sm font-bold">NUPTK</div>
            <div class="w-2/3 text-grey-darkest text-sm">{{ mutationInfo.teacher.nuptk }}</div>
          </div>
          <div class="flex flex-row mt-1">
            <div class="w-1/3 text-black text-sm font-bold">NIK</div>
            <div class="w-2/3 text-grey-darkest text-sm">{{ mutationInfo.teacher.nik }}</div>
          </div>
          <div class="flex flex-row mt-1">
            <div class="w-1/3 text-black text-sm font-bold">Status</div>
            <div class="w-2/3 text-grey-darkest text-sm">{{ mutationInfo.teacher.status }}</div>
          </div>
          <div class="flex flex-row mt-1">
            <div class="w-1/3 text-black text-sm font-bold">Ijazah</div>
            <div class="w-2/3 text-grey-darkest text-sm">{{ mutationInfo.teacher.ijazah }}</div>
          </div>
          <div class="flex flex-row mt-1">
            <div class="w-1/3 text-black text-sm font-bold">Sertifikasi</div>
            <div class="w-2/3 text-grey-darkest text-sm">{{ mutationInfo.teacher.sertifikasi }}</div>
          </div>
        </div>
        <div v-if="!isApproved" class="flex flex-col mt-4 px-2 text-sm">
          <div class="text-grey-darkest text-center">Setuju diredistribusi ke</div>
          <div class="mt-1 text-center">{{ mutationInfo.schoolTo.nama }}</div>
        </div>
        <div v-if="!isApproved" class="flex flex-row justify-center mt-4">
          <div v-if="isMutationAllowed" class="bg-brand hover:bg-brand-dark text-white text-sm font-bold py-1 px-2 rounded cursor-pointer mr-2" @click="approve">Ya</div>
          <div class="bg-grey-light hover:bg-grey text-white text-sm font-bold py-1 px-2 rounded cursor-pointer" :class="{ 'ml-2': isMutationAllowed }" @click="reject">Tidak</div>
        </div>
        <div v-if="isApproved" class="flex flex-col items-center mt-4 px-2 text-sm">
          <div class="text-grey-darkest self-center">Kode redistribusi <span class="text-grey-darker">(rahasia)</span></div>
          <div class="text-black text-lg mt-2 self-center">{{ code }}</div>
          <div class="bg-grey-light hover:bg-grey text-white text-sm font-bold py-1 px-2 rounded cursor-pointer mt-2" @click="reject">Tutup</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import {
  CHANGE_MUTATION_INFO,
  TOGGLE_MODAL_MUTATION,
  DISABLE_TEACHER
} from '@/mutationTypes'

export default {
  name: 'modal-mutation',
  props: {
    onTeacherClicked: Function,
    info: Object
  },
  computed: {
    ...mapState(['user', 'mutationInfo', 'selectedDistrict', 'selectedZone', 'selectedSchool', 'selectedTeacher', 'selectedCourse']),
    isMutationAllowed () {
      if (this.user.role === 'district' && (this.selectedDistrict.kode_wilayah !== this.user.district.properties.kode_wilayah)) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      code: '',
      isApproved: false,
      isSaving: false
    }
  },
  methods: {
    async approve () {
      this.isSaving = true
      try {
        let jsonBody = {
          nama_guru: this.mutationInfo.teacher.nama,
          status: this.mutationInfo.teacher.status,
          nik: this.mutationInfo.teacher.nik,
          nuptk: this.mutationInfo.teacher.nuptk,
          ijazah: this.mutationInfo.teacher.nama.ijazah,
          sertifikasi: this.mutationInfo.teacher.sertifikasi,
          link_info_gtk: 'http://info.gtk.kemdikbud.go.id/index.php?s=1&data=' + this.mutationInfo.teacher.token,
          sekolah_asal_id: this.mutationInfo.schoolFrom.sekolah_id,
          nama_sekolah_asal: this.mutationInfo.schoolFrom.nama,
          nama_mata_pelajaran_asal: this.mutationInfo.course,
          sekolah_tujuan_id: this.mutationInfo.schoolTo.sekolah_id,
          nama_sekolah_tujuan: this.mutationInfo.schoolTo.nama,
          nama_mata_pelajaran_tujuan: this.mutationInfo.course
        }
        let url = process.env.VUE_APP_API_URL + '/api/simrasio/addMutation/' + this.selectedSchool.properties.bentuk + '/' + this.selectedZone.zonasi_id
        let response = await fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(jsonBody)
        })
        this.isSaving = false
        let json = await response.json()
        if (json.status === 200) {
          this.isApproved = true
          this.code = json.code
          this.$store.dispatch(DISABLE_TEACHER, this.selectedTeacher)
          this.onTeacherClicked(this.selectedTeacher, this.selectedCourse, false)
        } else {
          this.isApproved = false
        }
      } catch (err) {
        // console.log(err)
        this.isApproved = false
      }
    },
    reject () {
      this.isApproved = false
      this.$store.dispatch(CHANGE_MUTATION_INFO, null)
      this.$store.dispatch(TOGGLE_MODAL_MUTATION, false)
    }
  }
}
</script>

<style>
</style>
